export const pharmacyOptions = (data) => {
	const mapOptions = data?.map((item) => ({
		label: item.name_editable,
		value: item.name,
	}));
	return mapOptions;
};
